import { Button, Modal } from "@ts-digital/vrc";
import numeral from "numeral";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import ReconciliationHeader from "../deadlines/details/register/reconciliationHeader";
import AddDeadlineForm from "./addDeadlineForm";
import CostForm from "./costForm";
import AddExistingDeadline from "./addExistingDeadline";
import LoaderSimple from "../general/loader";
import { createDeadlineWithUpload, createDeadlines } from "../../store/actions/deadlines/company";
import { createReconciliationLink, getReconciledSummary } from "../../store/actions/reconciliation/operations";
import { getEffectiveOrNot } from "../../store/actions/deadlines/accountant";
import { delay } from "../../libs/utils";

const ModalMovementsBigger = (props) => {
  const {
    difference,
    isModalVisible,
    setIsModalVisible,
    selectedMovementDetails,
    cancelText,
    saveText,
    valueRadio,
    setValueRadio,
    movementAmount,
    amountToPay,
    selectedDeadlines,
    setSelectedDeadlines,
    handleSelectedDeadlines,
    afterReconciliationEnd,
  } = props;
  const main = useSelector((state) => state.main);
  const auth = useSelector((state) => state.auth);
  const managerUuid = main.accountantUuidSelected;
  const itemUuid = main.companyUuidSelected;
  const dispatch = useDispatch();

  const requestBodyDefault = {
    counterpart: {
      description: "",
      taxId: "",
      vatNumber: "",
    },
    itemId: itemUuid,
    managerId: managerUuid,
    scope: "",
    type: "", // TODO capire dove inserire nel mockup manca
    description: {
      title: "",
      details: "",
    },
    status: {
      confirmed: true,
    },
    attachments: [],
    totalAmount: selectedMovementDetails.amount < 0 ? -difference : difference,
    payment: {
      type: selectedMovementDetails.paymentValue,
      status: selectedMovementDetails.amount < 0 ? "due" : "collect",
      compensation: false,
      mode: {},
    },
    date: moment(),
  };

  const [scopeError, setScopeError] = useState(false);
  const [counterpartError, setCounterpartError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [pIvaCounterpartError, setPIvaCounterpartError] = useState(false);
  const [CFCounterpartError, setCFCounterpartError] = useState(false);
  const [documentsAdded, setDocumentsAdded] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [scopeValue, setScopeValue] = useState(selectedMovementDetails.paymentValue);
  const [requestBody, setRequestBody] = useState(requestBodyDefault);
  const [dateError, setDateError] = useState(false);
  const [frequencyDates, setFrequencyDates] = useState({ startDate: null });
  const [documents, setDocuments] = useState([]);
  const [isSave, setIsSave] = useState(false);

  const amountResidueText = useIntl().formatMessage({
    id: "deadlines.merge.residual",
  });
  const movementDate = selectedMovementDetails.date;
  const paymentValue = selectedMovementDetails.paymentValue;

  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [selectedCounterparts, setSelectedCounterparts] = useState([]);
  const [filterDone, setFilterDone] = useState(false);
  const [deadlinesPlus, setDeadlinesPlus] = useState([]); // scadenze aggiuntive che seleziono tra quelle esistenti
  const [tooManyDeadlines, setTooManyDeadlines] = useState(false);

  useEffect(() => {
    setRequestBody({
      ...requestBody,
      scope: selectedMovementDetails.paymentValue < 0 ? "debt" : "credit",
    });
  }, [selectedMovementDetails?.paymentValue]);

  useEffect(() => {
    setRequestBody({
      ...requestBody,
      totalAmount: selectedMovementDetails.amount < 0 ? -difference : difference,
      type: selectedMovementDetails.amount < 0 ? "supplier" : "customer",
      payment: {
        type: selectedMovementDetails.amount < 0 ? "item_pays" : "item_collect",
        status: "verified",
        compensation: false,
        mode: { id: "PM05" },
      },
      counterpart: {
        ...requestBody.counterpart,
        description: selectedMovementDetails.reconciliationHintList ? selectedMovementDetails.reconciliationHintList?.[0]?.counterParty?.companyName : null,
        taxId: selectedMovementDetails.reconciliationHintList ? selectedMovementDetails.reconciliationHintList?.[0]?.counterParty?.taxId : null,
        vatNumber: selectedMovementDetails.reconciliationHintList ? selectedMovementDetails.reconciliationHintList?.[0]?.counterParty?.vatNumber : null,
      },
      description: {
        ...requestBody.description,
        title: selectedMovementDetails.description,
      },
      scope: selectedMovementDetails.amount < 0 ? "debt" : "credit",
    });
  }, [selectedMovementDetails, difference]);

  useEffect(() => {
    // setto a false l'isSave se cambia qualche parametro per evitare segnalazioni errori
    setIsSave(false);
  }, [requestBody]);

  const onSave = async (requestBodyDeadline) => {
    await dispatch(createDeadlines(requestBodyDeadline, true)).then((res) => {
      setTimeout(() => {
        let linkList = [];
        let allDeadlines = [...selectedDeadlines, res.id];
        allDeadlines.forEach((id) =>
          linkList.push({
            deadlineId: id,
            bankTransactionId: selectedMovementDetails.id,
          })
        );
        dispatch(createReconciliationLink(auth, main.accountantUuidSelected, main.companyUuidSelected, linkList, "BANK_TRANSACTION"))
          .then(afterReconciliationEnd())
          .then((res) => delay(3000).then(() => dispatch(getReconciledSummary())));
      }, 500);
    });
    setIsLoading(false);
    setIsSave(true);
    setDocuments([]);
    setIsModalVisible(false);
  };

  const handleSubmit = () => {
    switch (valueRadio) {
      case "1":
        if (filterDone) {
          // riconcilio movimento con scadenza selezionata tra quelle filtrate
          if (!startDateFilter || !endDateFilter) {
            setDateError(true);
            setTooManyDeadlines(false);
          } else if (deadlinesPlus.length > 1) {
            setDateError(false);
            setTooManyDeadlines(true);
          } else {
            setDateError(false);
            setTooManyDeadlines(false);
            let allSelected = selectedDeadlines.concat(deadlinesPlus);
            setSelectedDeadlines(allSelected);
            let linkList = [];
            allSelected.forEach((id) =>
              linkList.push({
                deadlineId: id,
                bankTransactionId: selectedMovementDetails.id,
              })
            );
            dispatch(createReconciliationLink(auth, main.accountantUuidSelected, main.companyUuidSelected, linkList, "BANK_TRANSACTION")).then(
              afterReconciliationEnd()
            );
            setIsModalVisible(false);
          }
        } else {
          // filtro le scadenze
          if (!startDateFilter || !endDateFilter) {
            setDateError(true);
          } else {
            setDateError(false);
            dispatch(
              getEffectiveOrNot(
                false,
                null,
                true,
                {
                  itemId: main.companyUuidSelected,
                  accountantId: main.accountantUuidSelected,
                  fromDate: startDateFilter,
                  toDate: endDateFilter,
                  reconciliated: false,
                  counterpartDescription: selectedCounterparts,
                  movementAmount: selectedMovementDetails.amount > 0 ? "positive" : "negative",
                  first: 50,
                },
                false
              )
            ).then((res) => {
              setFilterDone(true);
            });
          }
        }
        break;
      case "2":
        if (
          requestBody.description.title &&
          requestBody.scope &&
          (requestBody.type || requestBody.scope === "rent" || requestBody.scope === "financing" || requestBody.scope === "recurring_fees") &&
          requestBody.counterpart.description &&
          (requestBody.counterpart.description === "Erario" || requestBody.counterpart.vatNumber || requestBody.counterpart.taxId)
        ) {
          setIsLoading(true);
          dispatch(
            createDeadlineWithUpload(
              documentsAdded,
              requestBody,
              documents, // file già esistenti (lato sinistro) ,
              onSave
            )
          );
        } else {
          setDateError(!requestBody.date);
          setDescriptionError(!requestBody.description.title);
          setScopeError(!requestBody.scope);
          setPIvaCounterpartError(requestBody.counterpart.description !== "Erario" && !requestBody.counterpart.vatNumber && !requestBody.counterpart.taxId);
          setCounterpartError(!requestBody.counterpart.description);
          setCFCounterpartError(requestBody.counterpart.description !== "Erario" && !requestBody.counterpart.vatNumber && !requestBody.counterpart.taxId);
        }
        break;
      case "4":
        requestBody.payment.step = "rebated";
        dispatch(createDeadlines(requestBody, true));
        /**
       * TODO va creata una scadenza con step rebated, ma ad oggi non funziona
       * passando semplicemente lo step al create
      requestBody.payment.step="rebated";
      dispatch(createDeadlines(requestBody, true));
       */
        break;
      default:
        break;
    }
    if (valueRadio === "1" && !filterDone) {
    } else if (valueRadio === "1" && filterDone) {
    } else if (valueRadio === "2") {
    }
  };

  const resetFilterOrClose = () => {
    setTooManyDeadlines(false);
    if (!filterDone) {
      setIsModalVisible(false);
      setFilterDone(false);
    } else {
      setFilterDone(false);
    }
  };

  return (
    <div>
      <Modal
        title={`${amountResidueText}: ${numeral(Math.abs(difference)).format("0,0.00")} €`}
        visible={isModalVisible}
        onClose={() => {
          setIsModalVisible(false);
        }}
        outsideClosable={false}
        footer={
          !isLoading ? (
            <div className="dbx-register-modal-footer">
              <Button
                kind="secondary"
                colorScheme={"ghost"}
                style={{ marginRight: "16px" }}
                className="buttonNav"
                onClick={() => {
                  resetFilterOrClose();
                }}
              >
                {valueRadio !== "1" ? cancelText : filterDone ? "Torna ai filtri" : cancelText}
              </Button>
              <Button
                kind="primary"
                style={{
                  marginRight: "16px",
                  minWidth: valueRadio === "1" || valueRadio === "2" ? 270 : "unset",
                }}
                className="buttonNav"
                onClick={handleSubmit}
              >
                {valueRadio !== "1" ? saveText : filterDone ? "Associa al movimento" : "Applica filtri"}
              </Button>
            </div>
          ) : null
        }
      >
        <div style={{ display: "flex", maxWidth: "1026px", gap: "30px" }}>
          {!isLoading ? (
            <ReconciliationHeader
              amountToPay={amountToPay}
              residueAmount={difference}
              deadlineDate={movementDate}
              paymentValue={paymentValue}
              setValueRadio={setValueRadio}
              valueRadio={valueRadio}
              isMultipleReconciliation={true}
              isModalMovementsBigger={true}
              movementAmount={movementAmount}
            />
          ) : null}
          {valueRadio === "1" ? (
            <AddExistingDeadline
              handleSelectedDeadlines={handleSelectedDeadlines}
              selectedDeadlines={selectedDeadlines}
              startDateFilter={startDateFilter}
              setStartDateFilter={setStartDateFilter}
              endDateFilter={endDateFilter}
              setEndDateFilter={setEndDateFilter}
              selectedCounterparts={selectedCounterparts}
              setSelectedCounterparts={setSelectedCounterparts}
              filterDone={filterDone}
              setFilterDone={setFilterDone}
              residueAmount={difference}
              deadlinesPlus={deadlinesPlus}
              setDeadlinesPlus={setDeadlinesPlus}
              dateError={dateError}
              tooManyDeadlines={tooManyDeadlines}
            />
          ) : valueRadio === "2" ? (
            !isLoading ? (
              <AddDeadlineForm
                isSave={isSave}
                selectedMovementDetails={selectedMovementDetails}
                scopeError={scopeError}
                setScopeError={setScopeError}
                counterpartError={counterpartError}
                setCounterpartError={setCounterpartError}
                descriptionError={descriptionError}
                setDescriptionError={setDescriptionError}
                pIvaCounterpartError={pIvaCounterpartError}
                setPIvaCounterpartError={setPIvaCounterpartError}
                CFCounterpartError={CFCounterpartError}
                setCFCounterpartError={setCFCounterpartError}
                scopeValue={scopeValue}
                setScopeValue={setScopeValue}
                requestBody={requestBody}
                setRequestBody={setRequestBody}
                dateError={dateError}
                setDateError={setDateError}
                frequencyDates={frequencyDates}
                setFrequencyDates={setFrequencyDates}
                documents={documents}
                setDocuments={setDocuments}
                setDocumentsAdded={setDocumentsAdded}
              />
            ) : (
              <LoaderSimple message="Salvataggio in corso. Si prega di attendere" />
            )
          ) : valueRadio === "3" ? (
            <CostForm />
          ) : (
            <div style={{ minHeight: "480px", maxWidth: "750px" }}>
              <div className="reconciliation-subtitle">Abbuona</div>
              <div
                style={{
                  fontSize: "16px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                {useIntl().formatMessage(
                  { id: "reconciliation.abbuonoDescription" },
                  {
                    residueValue: <strong>{numeral(difference).format("0,0.00") + " €"}</strong>,
                    value: numeral(amountToPay).format("0,0.00") + " €",
                    totalAmount: numeral(movementAmount).format("0,0.00") + " €",
                  }
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ModalMovementsBigger;
